import React from 'react'
import { ReactComponent as MultiplyCircleIcon } from '@assets/images/Badge/multiply-circle.svg'
import type { BadgeProps } from './Badge.types'
import './Badge.css'

const Badge: React.FC<BadgeProps> = ({
  children,
  label = 'Label',
  mode = 'solid',
  darkMode = false,
  color = 'gray',
  dismissible = false,
  onDismiss,
  className = '',
  style,
}) => {
  const content = children ?? label
  const dismissLabel = typeof content === 'string' ? content : label || 'badge'
  // Dark mode → solid; light → tinted (`mode`).
  const resolvedMode = darkMode ? 'solid' : mode

  return (
    <span
      className={`ds-badge ds-badge--${resolvedMode} ds-badge--color-${color}${
        dismissible ? ' ds-badge--dismissible' : ''
      }${darkMode ? ' ds-badge--dark' : ''} ${className}`.trim()}
      style={style}
    >
      <span className="ds-badge__label">{content}</span>
      {dismissible && (
        <button
          type="button"
          className="ds-badge__dismiss"
          aria-label={`Remove ${dismissLabel}`}
          onClick={onDismiss}
        >
          <MultiplyCircleIcon className="ds-badge__dismiss-icon" />
        </button>
      )}
    </span>
  )
}

export default Badge
